/**
 * Bringing a step's target on screen, for tours that run with
 * `disableScrolling`.
 *
 * WHY THE TOURS DISABLE JOYRIDE'S OWN SCROLLING
 *
 * Joyride scrolls the window to each target, which fights with screens whose
 * content pane is its own `overflow: auto` container: it moves the page behind
 * the pane and the target stays exactly where it was. Four render sites turn it
 * off — Settings, Payment Insights, the messaging composer and the column
 * dialog — and then have to do the scrolling themselves.
 *
 * ONLY SETTINGS DID. The other three turned Joyride's scrolling off and put
 * nothing in its place, so a target below the fold was never brought into view
 * and Popper placed the tooltip against an off-screen rect. Measured on Payment
 * Insights at 1280x720 (scripts/probe-tour-placement.mjs), the last step —
 * "Payment Method Breakdown" — landed 203px below the bottom of the window,
 * taking its Next button with it. `preventOverflow` does not save you here: the
 * tooltip is not overflowing its boundary, the TARGET is outside the window and
 * the tooltip is faithfully next to it.
 *
 * 'instant', NOT 'smooth'. Popper measures the target as soon as the step
 * opens, and a smooth scroll is still in flight at that point — so the tooltip
 * gets placed against the position the target is leaving rather than the one it
 * arrives at. 'nearest' so a target already on screen is not jerked around.
 */

/**
 * Scroll a step's target into view. Call from `step:before`.
 *
 * @param step   the step Joyride is about to show
 * @param skip   optional predicate; return true to leave a step alone. A step
 *               targeting the whole dialog has nothing useful to scroll to.
 */
export function scrollStepIntoView(step, skip) {
    const target = step?.target;
    if (!target || typeof target !== 'string') return;
    //A `center` step is drawn in the middle of the viewport with no arrow and no
    //spotlight, so there is nothing for it to be beside and nothing to scroll.
    if (step.placement === 'center') return;
    if (skip?.(step)) return;
    document.querySelector(target)?.scrollIntoView({
        behavior: 'instant',
        block: 'nearest',
    });
}
